import getConfig from 'next/config'

import { TimelineType } from '@web/federation/gql/graphql'
import { ProofType } from '@web/gql/graphql'

export const PHASE = getConfig()?.publicRuntimeConfig?.PHASE ?? 'development'
export const CLIENT_VERSION = getConfig()?.publicRuntimeConfig?.CLIENT_VERSION
export const TAG = getConfig()?.publicRuntimeConfig?.TAG ?? 'development'
export const DEBUG = getConfig()?.publicRuntimeConfig?.DEBUG === 'true'
export const IS_DEV = PHASE === 'development' || PHASE === 'qa'
export const IS_BETA = PHASE === 'beta'
export const X_PORTA_AUTH = getConfig()?.publicRuntimeConfig?.X_PORTA_AUTH
  ? `Bearer ${getConfig()?.publicRuntimeConfig?.X_PORTA_AUTH}`
  : 'Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6InBvcnRhIn0.eyJpc3MiOiJwb3J0YSIsInN1YiI6Im15cGxhY2Utd2ViIiwiaWF0IjoxNzQxNjk2NDcyLCJjbGllbnRJZCI6Im15cGxhY2Utd2ViIiwic2NvcGUiOiJ3cml0ZTpyZXZpZXcifQ.ShqKJDEPVG3Z-YTLMAOqIfowRzNxORjCd5degO71FdWFncPuso4YUE3ta9IqcQznWAAYsOdY5Tsv2NftmiXyCScFk_P9zZTA7LRAqKljuTwkPwlOw8lug9QN0y80sN3QmX36t8L3GLdExHdp8tOQ2anXkyKJSjFdWlDdIa0jV8yjAzP-OJfUioT_037gUG8Ocomcmu19BKXEL0t4cSkI6aheCRWrXgU7MPlq1V18CZp7sq9zcnNUCN4dBli_VEWQPJ6uoGe2KLjPcVPsUbI5nH99UgueOb7ie333AUBupmDAFb5c6mqb1KpdBv9dy0XajYuTeT62oph3sKDZ3vx_hQ'

export const BASE_PATH = '/my'
const GLOBAL_CDN_PRODUCTION = 'https://g-myplace.pstatic.net/cdn' // 운영환경의 글로벌 CDN 주소 (nubes 운영환경과 연결)
/**
 * @see https://oss.navercorp.com/place/local/issues/16963#issuecomment-13318539
 * `public/web/static` 하위 파일 변경되어 운영 환경 반영이 필요하면 개발에서 테스트 후 nubescli 로 업로드 필요
 */
export const STATIC_BASE_PATH = IS_DEV ? '/my/web/static' : `${GLOBAL_CDN_PRODUCTION}/static`

export const IS_BROWSER = typeof window !== 'undefined'

export const PR_NUMBER = getConfig()?.publicRuntimeConfig?.PR_NUMBER
export const IS_PR_QA_MODE = !!PR_NUMBER && PHASE === 'qa'

export const MAX_NICKNAME_LENGTH = 20
export const MAX_INTRODUCTION_LENGTH = 150
export const MAX_UPLOAD_SIZE_MB = 10
export const MODAL_CONTENT_CLASS = 'place_modal_content_web'
export const MODAL_BG_CLASS = 'place_modal_bg'
export const PC_MODAL_BG_CLASS = 'pc_place_modal_bg'
export const TOAST_ROOT_ID = 'toast-root'
export const MODAL_ROOT_ID = 'modal-root'
export const MEDIA_VIEWER_ROOT_ID = 'modal-root'
export const DEFAULT_PAGE_TITLE = '네이버 MY플레이스'
export const DEFAULT_PAGE_DESCRIPTION = '나만의 장소 리스트를 만들고, 영수증으로 진짜 리뷰도 남겨보세요!'
export const DEFAULT_PAGE_IMAGE = `${STATIC_BASE_PATH}/images/og_tag_default.png`
export const DEFAULT_PROFILE_IMAGE = `${GLOBAL_CDN_PRODUCTION}/static/images/icon_profile_default.png`
export const DEFAULT_USER_NICKNAME = '플레이스 리뷰어'
export const MISSION_START_YEAR_MONTH = `2022-11`
export const MAPS_REFERRER_KEY = 'MAPS_REFERRER'
export const MYPLACE_OFFICIAL_IDNO = '2cqYTv'

const MAX_ADD_SINGLE_PLACE = 10
const MAX_FOLDERS = 400
export const MAX_REVIEW_SELECT = 10
const MIN_REVIEW_REPLY_TEXT_LENGHT = 5
export const MAX_SUBSCRIBE_REGIONS = 50

export const messages = {
  ERR_LOGIN: '로그인이 필요한 서비스입니다. 로그인하시겠습니까?',
  ERR_COMMON: '현재 서비스 이용이 원활하지 않습니다. 이용에 불편을 드려 죄송합니다.',
  ERR_FOLLOW: '팔로우 기능에 에러가 발생했습니다. 잠시 후 다시 시도해주세요.',
  ERR_MUTATION: '요청 처리 중 에러가 발생했습니다. 잠시 후 다시 시도해주세요.',
  ERR_SAVE_MUTATION: (
    <>
      일시적으로 변경사항을 저장할 수 없습니다.
      <br />
      잠시 후 다시 시도해주세요.
    </>
  ),
  ERR_VISIT_MUTATION: '방문 내역 변경 중 에러가 발생했습니다.',
  ERR_VISIT_DELETE: '방문 삭제 중 오류가 발생했습니다',
  ERR_REVIEW_MUTATION: '리뷰 내용 반영 중 에러가 발생했습니다.',
  ERR_CLIP_DELETE: '클립 삭제 중 오류가 발생했습니다',
  ERR_HIDE_REVIEWER: '추천 제외에 실패했습니다. 잠시 후 다시 시도해주세요.',
  ERR_FOLDER_OVERFLOW: `리스트는 ${MAX_FOLDERS}개까지 만들 수 있습니다.`,
  ERR_MAX_REVIEW_SELECT: `최대 ${MAX_REVIEW_SELECT}개까지 선택할 수 있습니다`,
  ERR_REMOVE_BOOKMARK: '장소 삭제중 에러가 발생하였습니다. 잠시후 다시 시도해 주세요',
  ERR_ADD_SINGLE_PLACE: `한 장소는 최대 ${MAX_ADD_SINGLE_PLACE}개까지 저장 가능합니다.`,
  ERR_MIN_REVIEW_REPLY_TEXT: `최소 ${MIN_REVIEW_REPLY_TEXT_LENGHT}자 이상 입력해 주세요.`,
  ERR_GET_FOLLOW_REQUESTS: '팔로우 요청 목록을 불러오는 도중 에러가 발생했습니다.',
  ERR_GET_FOLLOW_REQUESTERS: '팔로우 신청한 리뷰어 목록을 불러오는 도중 에러가 발생했습니다.',
  ERR_VALIDATE: '권한 체크중 일시적인 오류가 발생했습니다.',
  ERR_RECEIPT_SCAN_FAILED: '깨끗한 배경에 영수증을 놓고\n전체가 잘 나오도록 촬영해 주세요.',
  ERR_RECEIPT_UPLOAD_FAILED: '영수증 업로드 중 에러가 발생했습니다.',
  ERR_RECEIPT_DUPLICATE: '중복된 영수증을 업로드 하셨습니다.',
  ERR_VISIT_CREATE: '방문 내역 생성 중 에러가 발생했습니다.',
  ERR_NO_FUTURE_ON_VISIT_DATE: '방문일은 오늘 이후로 선택할 수 없습니다.',
  ERR_REVIEW_PAGE_LOAD_FAILED: '리뷰 작성 페이지를 불러올 수 없습니다',
  ERR_RECEIPT_IMAGE_LOAD_FAILED: '영수증 이미지를 불러올 수 없습니다',
  ERR_CONVERT_IMAGE: '이미지 변환에 실패했습니다.',
  ERR_DUPLICATE_NICKNAME_ALERT: '다른 닉네임을 입력해주세요.',
  ERR_MAX_UPLOAD_SIZE: `${MAX_UPLOAD_SIZE_MB}MB 미만의 이미지만 등록가능합니다. (현재: {size}MB)`,
  ERR_DUPLICATE_NICKNAME: '이미 사용중인 닉네임이에요.',
  ERR_PWORD_NICKNAME: '사용할 수 없는 단어가 포함되어 있어요',
  ERR_NEED_NICKNAME: '닉네임을 입력해주세요.',
  ERR_NO_SPACE_EDGE_NICKNAME: '공백으로 시작하거나 끝날 수 없습니다.',
  ONLY_ONE_NICKNAME: '하나뿐인 닉네임으로 잘 고르셨네요.',
  ERR_MAX_INTRODUCTION_ROW: '최대 7줄까지 쓸 수 있습니다.',
  LOGIN_NEED_ALERT: '네이버 로그인 하신 후 이용해 주시기 바랍니다.',
  ERR_INSPECTED_IMAGE: (
    <>
      <b>이용정책을 위반</b>하는 이미지로 의심되어 등록할 수 없습니다
    </>
  ),
  TRY_AGIN: '잠시 후 다시 시도해주세요.',
  ERR_INVALID_INTRODUCTION: '소개글은 최대 150자까지 쓸 수 있습니다.',
  WAIT_REQUEST: '요청을 처리중입니다.',
  NICKNAME_RULE: '한글, 영문, 숫자 2~20자까지 입력할 수 있어요.',
  ERR_PWORD: '{type}에 사용할 수 없는 문구가 포함되어 있습니다. ({pword})', // replace 로 사용
  NONE_PLACE_ADDRESS: '정보 없음',
  NOT_AVAILABLE_PLACE: '장소가 존재하지 않거나 정보 제공이 중지되었습니다.',
  DELETE_VISIT_WITH_REVIEW_CONFIRM:
    '이미 작성한 리뷰와 함께 참여한 미션\n 스탬프도 함께 삭제되며,\n 이후 다시 인증할 수 없습니다.\n 삭제하시겠습니까?',
  DELETE_VISIT_CONFIRM: '이후 다시 인증하거나 리뷰를 작성할\n수 없습니다. 삭제하시겠습니까?',
  DELETE_PAYMENT_CONFIRM: '결제 내역을 삭제하면 다시 확인할 수 없습니다. 삭제하시겠습니까?',
  REPORT_PAYMENT_CONFIRM: '결제 내역이 잘못 분류되어 있다면 알려주세요.\n서비스 개선에 큰 도움이 됩니다',
  REPORT_PAYMENT_LINK: '결제 내역 관련 도움말 확인하기',
  NOT_FOUND_VISIT: '방문이 존재하지 않습니다.',
  ERR_UPLOAD_IMAGE: '이미지 업로드를 실패했습니다.',
} as const

export const NID_SVC_TYPE = 262144

export const GLOBAL_STYLES = {
  placeModalContent: MODAL_CONTENT_CLASS,
  placeScrollableModalContent: 'place_scrollable_modal_content',
  placeBtnFold: 'place_btn_fold',
  placeBtnFoldActive: 'place_is_folded',
}

export const REGEXS = {
  NICKNAME: /^[a-zA-Z0-9ㄱ-ㅎ가-힣 ]{2,20}$/,
} as const

export type OrderTimelineType = Extract<
  TimelineType,
  TimelineType.Delivery | TimelineType.DriveThru | TimelineType.Pickup | TimelineType.TableOrder
>
/** 예약 > 주문 proof type */
export const BOOKING_ORDER_PROOF_TYPES: ProofType[] = [
  ProofType.Delivery,
  ProofType.DriveThru,
  ProofType.Pickup,
  ProofType.TableOrder,
]

/** 예약 proof type */
export const BOOKING_PROOF_TYPES: ProofType[] = [...BOOKING_ORDER_PROOF_TYPES, ProofType.Reservation]

export const RECOMMEND_CATEGORY_CODES = [
  '220036', // 음식점
  '223268', // 미용
  '221941', // 숙박
  '221845', // 문화/예술
  '221986', // 스포츠/오락
  '222117', // 여행/명소
]

/** https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key */
export const KeyboardEventKey = {
  ENTER: 'Enter',
}

export const AUTH_COOKIE = {
  NID_SES: 'NID_SES',
  NID_AUT: 'NID_AUT',
}

type ViewPage = 'checkin' | 'review'
export const PROOF_LABEL_MAP: Record<ViewPage, Record<ProofType, string | null>> = {
  checkin: {
    [ProofType.Receipt]: '영수증',
    [ProofType.Reservation]: '예약',
    [ProofType.Payment]: '결제내역',
    [ProofType.DriveThru]: '포장주문',
    [ProofType.Pickup]: '포장주문',
    [ProofType.TableOrder]: '매장주문',
    [ProofType.Delivery]: '배달주문',
    [ProofType.Hotel]: '네이버호텔',
    [ProofType.Nft]: null,
    [ProofType.TrainTicket]: '승차권',
    [ProofType.Gps]: null,
    [ProofType.Search]: null,
    [ProofType.Media]: null,
  },
  review: {
    [ProofType.Receipt]: '영수증',
    [ProofType.Reservation]: '예약',
    [ProofType.Payment]: '결제내역',
    [ProofType.Delivery]: '주문',
    [ProofType.DriveThru]: '주문',
    [ProofType.Pickup]: '주문',
    [ProofType.TableOrder]: '주문',
    [ProofType.Hotel]: '네이버호텔',
    [ProofType.Nft]: null,
    [ProofType.TrainTicket]: '승차권',
    [ProofType.Gps]: null,
    [ProofType.Search]: null,
    [ProofType.Media]: null,
  },
}

/**
 * Context 초기값 정의등 구현체가 필요하지 않은데 타입상 넣어야할 경우 사용
 */
export const voidCallback = () => {}
